import { render, staticRenderFns } from "./Exit.vue?vue&type=template&id=4fbbb36a&"
import script from "./Exit.vue?vue&type=script&lang=js&"
export * from "./Exit.vue?vue&type=script&lang=js&"
import style0 from "./Exit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports